import { StoreExt } from '@utils/reactExt'
import { observable, action, runInAction } from 'mobx'
import { createRandomCode } from '@src/utils';
import { userStore } from '@src/store';
import { EVENT_TRACING_PAGE, EVENT_TRACING_CLICK } from '@constants/index'

class LoginStore extends StoreExt {
    @observable randomCode: string = createRandomCode()
    @observable captchaUrl: string = this.api.getCaptchaUrl(this.randomCode)
    @observable captchaCustomUrl: string = ''
    @observable showCustom: boolean
    @observable loginStatus: boolean = false // 登录交互

    // 登录状态
    @action
    setLoginStatus = (val: boolean) => runInAction(() => this.loginStatus = val)

    @action
    refresh = () => {
        const randomCodeUrl = createRandomCode()
        runInAction(() => {
            this.randomCode = randomCodeUrl
            this.captchaUrl = this.api.getCaptchaUrl(randomCodeUrl)
        })
    }

    @action
    refreshCustom = async () => {
        const randomCodeUrl = createRandomCode()
        try {
            const response = await this.api.getCaptchaCustomUrl(randomCodeUrl)
            runInAction(() => {
                this.randomCode = randomCodeUrl
                // 根据返回的数据格式处理
                if (typeof response === 'string') {
                    // 如果返回的是base64字符串
                    this.captchaCustomUrl = `data:image/png;base64,${response}`
                } else {
                    // 如果返回的是其他格式，尝试直接使用
                    this.captchaCustomUrl = response
                }
            })
        } catch (error) {
            console.error('获取自定义验证码失败:', error)
            runInAction(() => {
                this.randomCode = randomCodeUrl
                this.captchaCustomUrl = ''
            })
        }
    }

    // 手机登录
    @action
    loginByPhone = async (param = {}) => {
        this.setLoginStatus(true)
        await this.api.loginByPhone(param).catch(e => {
            this.setLoginStatus(false)
            this.refresh()
        })
        userStore.sendEventTracing({
            pageCode: EVENT_TRACING_PAGE.LOGIN,
            buttonCode: EVENT_TRACING_CLICK.OP_LOGIN,
            buttonInfo: 'phone' // 登录方式
        })
        await userStore.getUserInfo(false) // 查询用户信息
        this.setLoginStatus(false)
    }

    // 用户登录
    @action
    loginByUser = async (param = {}) => {
        this.setLoginStatus(true)
        await this.api.loginByUser(param).catch(err => {
            this.setLoginStatus(false)
            this.refreshCustom()
            if (err.err.code === '4001') {
                runInAction(() => this.showCustom = true)
            }
        })
        userStore.sendEventTracing({
            pageCode: EVENT_TRACING_PAGE.LOGIN,
            buttonCode: EVENT_TRACING_CLICK.OP_LOGIN,
            buttonInfo: 'user' // 登录方式
        })
        await userStore.getUserInfo(false) // 查询用户信息
        this.setLoginStatus(false)
    }

    @action
    getLoginMsgCode = async (param, fn?) => {
        await this.api.getLoginMsgCode(param).catch(e => {
            if (!!fn) {
                fn()
            }
            this.refresh()
        })
        this.$toast.info('获取成功')
    }
}

const loginStore = new LoginStore()
export { loginStore, LoginStore }
